import type { ViewerPluginCreator } from './../ricos-types';

import nodeViewDecorator from './nodeViewDecorator';
import type { TextColorPluginViewerConfig, TextHighlightPluginViewerConfig } from './types';
import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from './types';

export const pluginTextColor: ViewerPluginCreator<TextColorPluginViewerConfig> = (config = {}) => {
  return {
    config,
    type: TEXT_COLOR_TYPE,
    nodeViewDecorators: [nodeViewDecorator],
  };
};

export const pluginTextHighlight: ViewerPluginCreator<TextHighlightPluginViewerConfig> = (
  config = {}
) => {
  return {
    config,
    type: TEXT_HIGHLIGHT_TYPE,
  };
};
